import React from "react";

export const NoOutstandingRequestsIndicator = () => (
    <div id="no-outstanding-requests-indicator" style={{display: "none"}} />
);
